import {ParamCodeExporter} from '../Param';
import {RampParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/Ramp';

export class ParamRampCodeExporter extends ParamCodeExporter<RampParam> {
	override default_value() {
		// do not use JSON.stringify, otherwise, copy/paste fails for spare params
		return this._param.defaultValueSerialized();
	}

	override add_main() {
		let val = this._param.value;
		const json = val.toJSON();
		const line = this.prefix() + `.set(${JSON.stringify(json)})`;
		this._lines.push(line);
	}
}
